<template>
	<div class="loader ease-linear rounded-full border-2 border-t-2 border-gray-400 h-6 w-6"></div>
</template>

<script>
export default {
	name: "RpSpinner"
};
</script>

<style scoped>
.loader {
	border-top-color: #4f67b9;
	-webkit-animation: spinner 1.5s linear infinite;
	animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
	0% {
		-webkit-transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
	}
}

@keyframes spinner {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>